// Core fallbacks (ARCHITECTURE §3): the boot loader shown before the tenant
// resolves, and the app-level Suspense fallback (admin chunks, a cold
// non-classic template chunk, and classic's lazy pages, which suspend the
// app-level boundary exactly as before).
//
// It paints the ground of the surface that is about to appear, with no text
// (#841): it used to paint Classic's navy gradient and "Loading..." before
// every surface, including the light admin and the Arena/Huddle sites.
//   - /admin*: the admin canvas, light or dark from the admin's own mode
//     (data-adm-mode once the shell has mounted, else the mirrored
//     preference, else the OS setting).
//   - the public site: Classic's gradient for Classic (and when the template
//     isn't known yet); another template's canvas once its stylesheet is in,
//     else the league's own background colour.

const ADMIN_CANVAS = { light: '#F7F5F1', dark: '#151310' } as const

function adminMode(): 'light' | 'dark' {
  const pick = (m: unknown): 'light' | 'dark' | null => (m === 'light' || m === 'dark' ? m : null)
  const fromHtml = document.documentElement.getAttribute('data-adm-mode')
  let stored: unknown = null
  try {
    stored = (JSON.parse(localStorage.getItem('adm_prefs') ?? 'null') as { color_mode?: unknown } | null)?.color_mode
  } catch {
    stored = null
  }
  return pick(fromHtml) ?? pick(stored) ?? (window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
}

function publicTemplate(): string {
  const live = document.documentElement.getAttribute('data-site-template')
  if (live) return live
  try {
    // The dev/staging override (devOverride.ts) wins over the published choice.
    const override = JSON.parse(sessionStorage.getItem('scorelm:template-override') ?? 'null') as { id?: string } | null
    if (override?.id) return override.id
  } catch {
    // ignore
  }
  try {
    const cached = JSON.parse(localStorage.getItem(`mcl_tenant_${window.location.hostname}`) ?? 'null') as { site_template?: { id?: string } } | null
    return cached?.site_template?.id || 'classic'
  } catch {
    return 'classic'
  }
}

export default function BootLoader() {
  if (window.location.pathname.startsWith('/admin')) {
    return <div className="min-h-screen" style={{ background: ADMIN_CANVAS[adminMode()] }} aria-busy="true" />
  }
  if (publicTemplate() === 'classic') {
    return <div className="min-h-screen bg-gradient-to-b from-bg-secondary via-bg-primary to-bg-primary" aria-busy="true" />
  }
  return <div className="min-h-screen" style={{ background: 'rgb(var(--st-canvas, var(--color-bg-primary)))' }} aria-busy="true" />
}
